export default "dist/images/block-feature-grid-basic.a0cdc79.png";